interface ParsedListItem {
  value: string
  next: number
}

function skipWhitespace(source: string, start: number, end: number): number {
  let cursor = start
  while (cursor < end && /\s/u.test(source[cursor] ?? '')) cursor += 1
  return cursor
}

function readSingleQuotedItem(source: string, start: number, end: number): ParsedListItem | null {
  if (source[start] !== "'") return null
  let cursor = start + 1
  let value = ''
  while (cursor < end) {
    const character = source[cursor]
    if (character === "'") return { value, next: cursor + 1 }
    if (character === '\\') {
      const escaped = source[cursor + 1]
      if (escaped !== "'" && escaped !== '\\') return null
      value += escaped
      cursor += 2
      continue
    }
    if (character === undefined) return null
    value += character
    cursor += 1
  }
  return null
}

function parseLegacySingleQuotedList(source: string): string[] | null {
  const result: string[] = []
  const end = source.length - 1
  let cursor = skipWhitespace(source, 1, end)
  if (cursor === end) return result

  while (cursor < end) {
    const item = readSingleQuotedItem(source, cursor, end)
    if (!item) return null
    result.push(item.value)
    cursor = skipWhitespace(source, item.next, end)
    if (cursor === end) return result
    if (source[cursor] !== ',') return null
    cursor = skipWhitespace(source, cursor + 1, end)
    if (cursor === end) return null
  }
  return null
}

function parseJsonStringList(source: string): string[] | null {
  try {
    const parsed: unknown = JSON.parse(source)
    return Array.isArray(parsed) && parsed.every((item) => typeof item === 'string') ? parsed : null
  } catch {
    return null
  }
}

function reportMalformedList(): void {
  // Recipient values are PII. Record the contract failure without echoing the payload.
  console.warn('[alerts] Ignoring a malformed scalar-list payload.')
}

/** Normalizes backend arrays and legacy encoded lists without eval or quote replacement. The live
 *  registry sends `null` for an unset `whatsapp_numbers` rather than omitting or emptying it. */
export function alertScalarList(value: string[] | string | null | undefined): string[] {
  if (value === null || value === undefined) return []
  if (Array.isArray(value)) return [...value]
  const normalized = value.trim()
  if (!normalized) return []
  if (!normalized.startsWith('[') || !normalized.endsWith(']')) return [normalized]
  const parsed = parseJsonStringList(normalized) ?? parseLegacySingleQuotedList(normalized)
  if (parsed) return parsed
  reportMalformedList()
  return []
}
